import LayoutProvider from '../../../../../../Contexts/LayoutProvider';
import LibModal from '../../../../../../features/LibModal/LibModal';
import { ButtonPrimary } from '../../../../../../utils/Button';
import UpdatePackageServiceModal from '../../Modals/UpdatePackageServiceModal';
import { useProductDt } from '../../ProductDetailsProvider';
import TableMobile from './TableMobile';
import TableWeb from './TableWeb';

function ServicesTable({ show }) {
    const { modalType, closeModal, modalData, openModal, packageInfo, productInfo, handleReload } =
        useProductDt();
    // check package and product status
    const isPackageOrProductInactive =
        packageInfo?.status === 'inactive' || productInfo?.status === 'inactive';
    if (!show) {
        return null;
    }
    return (
        <div className="mb-40">
            <LayoutProvider>
                <TableWeb
                    layout="default"
                    packageInfo={packageInfo}
                    productInfo={productInfo}
                    openModal={openModal}
                    handleReload={handleReload}
                />

                <TableMobile
                    layout={['lg', 'md', 'sm', 'xs', 'xxs']}
                    packageInfo={packageInfo}
                    productInfo={productInfo}
                    handleReload={handleReload}
                    openModal={openModal}
                />
            </LayoutProvider>

            <div className="flex justify-end">
                <ButtonPrimary
                    title="Add +"
                    disabled={isPackageOrProductInactive}
                    onClick={() => openModal('addService')}
                />
            </div>

            {modalType === 'service-pricing' && (
                <LibModal title="Update Service Price" setOpen={closeModal}>
                    <UpdatePackageServiceModal
                        closeModal={closeModal}
                        handleReload={handleReload}
                        modalData={modalData}
                        productInfo={productInfo}
                        packageInfo={packageInfo}
                    />
                </LibModal>
            )}
        </div>
    );
}

export default ServicesTable;
